'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchPublicGlobalBrandingFailed = exports.fetchPublicGlobalBrandingSucceeded = exports.fetchPublicGlobalBrandingAction = undefined;
exports.fetchGlobalBranding = fetchGlobalBranding;

var _ActionTypes = require('MeetingsLib/redux/actions/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _publicGlobalBrandingAPI = require('MeetingsLib/api/publicGlobalBrandingAPI');

var _actions = require('MeetingsBase/utils/actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fetchPublicGlobalBrandingAction = exports.fetchPublicGlobalBrandingAction = (0, _actions.createRequestAction)(_ActionTypes2.default.PUBLIC_GLOBAL_BRANDING_FETCH_STARTED);

var fetchPublicGlobalBrandingSucceeded = exports.fetchPublicGlobalBrandingSucceeded = (0, _actions.createRequestAction)(_ActionTypes2.default.PUBLIC_GLOBAL_BRANDING_FETCH_SUCCEEDED, function (payload) {
  return payload;
});

var fetchPublicGlobalBrandingFailed = exports.fetchPublicGlobalBrandingFailed = (0, _actions.createRequestAction)(_ActionTypes2.default.PUBLIC_GLOBAL_BRANDING_FETCH_FAILED, function (error) {
  return { error: error };
});

function fetchGlobalBranding(portalId, userId) {
  return function (dispatch, getState, httpClient) {
    dispatch(fetchPublicGlobalBrandingAction());
    return (0, _publicGlobalBrandingAPI.fetchPublicGlobalBranding)(httpClient, portalId, userId).then(function (response) {
      dispatch(fetchPublicGlobalBrandingSucceeded(response));
    }, function (error) {
      dispatch(fetchPublicGlobalBrandingFailed(error));
    });
  };
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/redux/actions/PublicGlobalBrandingActions.js
// module id = 322
// module chunks = 0